module.exports = __webpack_public_path__ + "img/login_tab01_03.2af41dd4.png";